import { BiEnvelope, BiMapAlt } from 'react-icons/bi';
import { FaPhoneAlt } from 'react-icons/fa';
import { GrAlarm } from 'react-icons/gr';
import './Contactinfo.css';

const Contactinfo = ({ title, details, subTitle }) => {
  return (
    <section className='contact-info'>
      <div className='container p-6  mx-auto'>
        <div className='grid grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-4'>
          <div className='info-item  flex flex-col justify-center items-center relative'>
            <div className='contact-icons mb-[15px]'>
              <BiMapAlt className='' size='35px' color='#fff'></BiMapAlt>
            </div>
            <h3>Office Address</h3>
            <p className='text-base font-medium'>
              Kahatergaon, Barachapa-1652, Monohardi, Narsingdi, Bangladesh
            </p>
          </div>
          <div className='info-item  flex flex-col justify-center items-center relative'>
            <div className='contact-icons mb-[15px]'>
              <FaPhoneAlt className='' size='35px' color='#fff'></FaPhoneAlt>
            </div>
            <h3>Call Us</h3>
            <p className='text-base font-medium'>+8801345336969</p>
          </div>
          <div className='info-item  flex flex-col justify-center items-center relative'>
            <div className='contact-icons mb-[15px]'>
              <BiEnvelope className='' size='35px' color='#fff'></BiEnvelope>
            </div>
            <h3>Email Us</h3>
            <p className='text-base font-medium'>
              msolaimantechnicalcenter@gmail.com
            </p>
          </div>
          <div className='info-item  flex flex-col justify-center items-center relative'>
            <div className='contact-icons mb-[15px]'>
              <GrAlarm className='' size='35px' color='#fff'></GrAlarm>
            </div>
            <h3>Open Time</h3>
            <p className='text-base font-medium'>Sat - Thu: 8:00Am - 5:00 Pm</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contactinfo;
